import React from "react";
import {
  Arrow,
  Container,
  Lock,
  MainArrowContainer,
  NavCards,
  NavCardsAnchorsContainer,
  NavCardsContainer,
  NavCardsContent,
  NavSubCardsContainer,
  ToolTipContainer,
  ToolTipIndicator,
} from "./styles";
import lock from "../../assets/icons/Lock.svg";
import arrow from "../../assets/icons/Arrow.svg";
import { SubCard } from "../sub-card";
import faq from "../../assets/icons/FAQ.svg";
import patient from '../../assets/icons/Patient.svg';
import surgeon from '../../assets/icons/Surgeon.svg';
import secretariat from '../../assets/icons/Secretariat.svg';
import provider from '../../assets/icons/Provider.svg';

interface IAsideMenu {
  state?: number;
}

export const AsideMenu: React.FC<IAsideMenu> = ({ state }) => {
  const [opened, setOpened] = React.useState(
    window.innerWidth < 840 ? true : false
  );
  const [mainColapsed, setMainColapsed] = React.useState(-1);
  const [colapsed, setColapsed] = React.useState(-1);
  const [focus, setFocus] = React.useState(-1);
  const [first, setFirst] = React.useState(true);

  React.useEffect(() => {
    if (state !== -1) {
      setOpened((old) => !old);
    }
    if(window.location.pathname.split('/')[1] === 'faq') {
      setColapsed(0);
      setMainColapsed(1);
      setFocus(0);
    }
  }, [state]);

  React.useEffect(() => {
    setTimeout(() => {setFirst(false)},100);
  },[])

  return (
    <>
      <Container className={`${opened ? "active" : ""}`}>
        <NavCardsContainer
          className={`${focus === -1 ? "full-" : ""}${
            mainColapsed === 0 ? "open" : ""
          }`}
        >
          <NavCards
            onClick={() => {
              if(window.location.pathname.split('/')[1] === 'faq'){
                window.location.replace('/');
                return;
              }
              if (colapsed !== 0 || mainColapsed !== 0) {
                setColapsed(0);
                setMainColapsed(0);
                setFocus(0);
                return;
              }
              setMainColapsed(-1);
              setFocus(0);
              setColapsed(-1);
            }}
            className={`${mainColapsed === 0 ? "active" : ""}${
              opened ? " hide" : ""
            }`}
          >
            <Lock src={lock} />
            <NavCardsContent>Privacidade e segurança</NavCardsContent>
            <Arrow className={`${colapsed >= 0 && mainColapsed === 0 ? "flip" : ""}`} src={arrow} />
          </NavCards>
          <NavSubCardsContainer className={focus === 0 && mainColapsed === 0 ? "open" : focus > 0 && mainColapsed === 0 ? "full":''}>
            <NavCards
              width={91}
              onClick={() => {
                if (colapsed !== 1) {
                  setFocus(1);
                  setColapsed(1);
                  return;
                }
                if (focus === 0) {
                  setFocus(1);
                  return;
                }
                setFocus(0);
              }}
              className={`${
                colapsed === 1 && mainColapsed === 0? "active" : colapsed >= 0 && mainColapsed === 0? "" : "hidden"
              }${opened ? " hide" : ""}`}
            >
              <Lock src={lock} />
              <NavCardsContent fontSize={20.7}>
                Política de privacidade
              </NavCardsContent>
              <Arrow
                className={`${colapsed === 1 && mainColapsed === 0? "flip" : ""}${
                  focus === 0 ? "-only" : ""
                }`}
                src={arrow}
              />
            </NavCards>
            <NavCardsAnchorsContainer
              className={`${focus === 1 && mainColapsed === 0? "open" : ""}`}
            >
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-1"
                state={opened}
                content={
                  "1 - Quais dados coletamos sobre voce e para qual finalidade"
                }
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-2"
                state={opened}
                content={"2 - Como coletamos os seus dados"}
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-3"
                state={opened}
                content={"3 - Quais são os seus direitos"}
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-4"
                state={opened}
                content={"4 - Como voce pode exercer seus direitos de titular"}
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-5"
                state={opened}
                content={
                  "5 - Como e por quanto tempo seus dados serão armazenados"
                }
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-6"
                state={opened}
                content={"6 - O que fazemos para manter seus dados seguros?"}
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-7"
                state={opened}
                content={"7 - Com quem seus dados podem ser compartilhados?"}
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-8"
                state={opened}
                content={"8 - Cookies ou dados de navegação"}
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-9"
                state={opened}
                content={"9 - Alteração desta Política de Privacidade"}
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-10"
                state={opened}
                content={"10 - Responsabilidade"}
              />
              <SubCard
                className={`${colapsed === 1 && focus === -1 ? "show" : ""}`}
                onClick={() => {
                  setOpened((old) => !old);
                }}
                hRef="privacity-11"
                state={opened}
                content={"11 - Encarregado da proteção de dados"}
              />
            </NavCardsAnchorsContainer>
            <NavCards
              width={91}
              className={`${
                colapsed === 2 && mainColapsed === 0? "active" : colapsed >= 0 && mainColapsed === 0? "" : "hidden"
              }${opened ? " hide" : ""} disabled`}
            >
              <Lock src={lock} />
              <NavCardsContent fontSize={20.7}>Termos de uso</NavCardsContent>
              <Arrow
                className={`${colapsed === 2 ? "flip" : ""}${
                  focus === 1 ? "-only" : ""
                }`}
                src={arrow}
              />
              <ToolTipContainer className={"container"}>
                Em breve
                <ToolTipIndicator className={"indicator"} />
              </ToolTipContainer>
            </NavCards>
          </NavSubCardsContainer>
        </NavCardsContainer>
        <NavCardsContainer>
          <NavCards
            onClick={() => {
              if (colapsed !== 0 || mainColapsed !== 1) {
                setColapsed(0);
                setMainColapsed(1);
                setFocus(0);
                return;
              }
              setMainColapsed(-1);
              setFocus(0);
              setColapsed(-1);
            }}
            className={`${mainColapsed === 1 ? "active" : ""}${
              opened ? " hide" : ""
            }`}
          >
            <Lock marginRight={-5} marginLeft={-5} width={24} src={faq} />
            <NavCardsContent>FAQ</NavCardsContent>
            <Arrow transition={first} className={`${colapsed >= 0 && mainColapsed === 1? "flip" : ""}`} src={arrow} />
          </NavCards>
          <NavSubCardsContainer className={focus !== 0 && mainColapsed !== 1 ? "open" : ''}>
            <NavCards
              width={91}
              onClick={() => {
                window.location.replace("/faq/patients");
              }}
              className={`${
                opened ? " hide" : ""
              } ${
                colapsed === 0 && mainColapsed === 1 ? '':'hide'
              }${
                window.location.pathname.split('/')[2] === 'patients' && colapsed === 0 && mainColapsed === 1? 'active':''
              }`}
            >
              <Lock marginRight={-5} marginLeft={-5} width={24} src={patient} />
              <NavCardsContent>Pacientes</NavCardsContent>
            </NavCards>
            <NavCards
              width={91}
              onClick={() => {
                window.location.replace("/faq/surgeon");
              }}
              className={`${
                opened ? " hide" : ""
              } ${
                colapsed === 0 && mainColapsed === 1 ? '':'hide'
              }${
                window.location.pathname.split('/')[2] === 'surgeon' && colapsed === 0 && mainColapsed === 1? 'active':''
              }`}
            >
              <Lock marginRight={-5} marginLeft={-5} width={24} src={surgeon} />
              <NavCardsContent>Cirurgião</NavCardsContent>
            </NavCards>
            <NavCards
              width={91}
              onClick={() => {
                window.location.replace("/faq/secretariat");
              }}
              className={`${
                opened ? " hide" : ""
              } ${
                colapsed === 0 && mainColapsed === 1 ? '':'hide'
              }${
                window.location.pathname.split('/')[2] === 'secretariat' && colapsed === 0 && mainColapsed === 1 ? 'active':''
              }`}
            >
              <Lock marginRight={-5} marginLeft={-5} width={24} src={secretariat} />
              <NavCardsContent>Secretariado</NavCardsContent>
            </NavCards>
            <NavCards
              width={91}
              onClick={() => {
                window.location.replace("/faq/provider");
              }}
              className={`${
                opened ? " hide" : ""
              } ${
                colapsed === 0 && mainColapsed === 1 ? '':'hide'
              }${
                window.location.pathname.split('/')[2] === 'provider' && colapsed === 0 && mainColapsed === 1 ? 'active':''
              }`}
            >
              <Lock marginRight={-5} marginLeft={-5} width={24} src={provider} />
              <NavCardsContent>Fornecedor</NavCardsContent>
            </NavCards>
          </NavSubCardsContainer>
        </NavCardsContainer>
      </Container>
      <MainArrowContainer
        onClick={() => {
          setOpened((old) => !old);
        }}
        className={`${opened ? "move" : ""}`}
      >
        <Arrow className={`main${opened ? " flip" : ""}`} src={arrow} />
      </MainArrowContainer>
    </>
  );
};
